<template>
  <div>
    <div class="summary" ref="cardSummary">
      <div class="summary-title">
        <div><h2>Resumo</h2></div>
        <div class="ranking" v-if="items.length > 1">
          <v-tooltip top>
            <v-select
              slot="activator"
              prepend-icon="emoji_events"
              hide-details
              v-model="ranking"
              :items="itemsRanking"
              @change="changeRanking"
              dense
              style="padding-top: 0px; margin-top: 0px"
            ></v-select>
          <span>Selecione o ranqueamento</span>
        </v-tooltip>
        </div>
        <div class="menu">
          <div class="paginating">
            <v-btn x-small flat icon :disabled="first || itemsProp.length <= qtt" @click="updateData(-1)" color="black">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-avatar size="25" color="black">
              <span class="white--text" style="font-size: 12px">{{(index + 1) + '/' + (itemsLength === 0 ? 1 : Math.ceil(itemsLength / qtt))}}</span>
            </v-avatar>
            <v-btn flat icon :disabled="last || itemsProp.length <= qtt" @click="updateData(1)" color="black">
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </div>
          <!-- <v-tooltip top>
            <v-icon slot="activator" color="black" size="20px">{{'info'}}</v-icon>
            <span class="dica">Mostra os principais indicadores por usuário.

Performance : Mostra a porcentam de tarefas concluídas sobre as previstas.

Horas Trabalhadas : Mostra a quantidade de horas trabalhadas no dia

Tarefas concluídas : Mostra a quantidade de tarefas concluídas no dia

Tarefas Previstas : Mostra a quantidade de tarefas com a data de previsão para hoje

Tarefas Atrasadas : Mostra a quantidade de tarefas com a data de previsão maior que a data de hoje</span>
          </v-tooltip> -->
        </div>
      </div>
      <div class="center content" v-if="loading">
        <img class="loader" :src="`${basePath}images/loader.gif`" width="100px" />
      </div>
      <div v-else-if="items.length > 0" class="content">
        <div class="item" v-for="item in items" :key="item.id">
          <!-- Origem da Tarefa -->
          <v-avatar v-if="(ranking > 0) && (items.length > 1)" :size="(allItems.findIndex((val) => val.index === item.index) > 2 ? '30' : '35')" :color="(allItems.findIndex((val) => val.index === item.index) == 0 ? '#D4AF37' : (allItems.findIndex((val) => val.index === item.index) == 1 ? '#A9A9A9' : (allItems.findIndex((val) => val.index === item.index) == 2 ? '#B87333' : 'white')))" class="ranking-cicle elevation-7 avatar">
            <span class="ranking-number" :style="(allItems.findIndex((val) => val.index === item.index) > 2 ? 'color:#808080; font-size: 1.3em;' : 'color:white; font-size: 1.5em;')"> {{allItems.findIndex((val) => val.index === item.index) + 1}}° </span>
          </v-avatar>
          <div class="image mr-2">
            <div v-if="item.user">
              <v-tooltip top>
                <img slot="activator" v-if="item.photo" class="mr-2" :src="`${basePath}uploads/users/${item.photo}`" alt="avatar">
                <div slot="activator" class="usuario" v-else>
                  <h3>{{getFirstLetters(item.user)}}</h3>
                </div>
                <span>{{item.user}}</span>
              </v-tooltip>
            </div>
            <div v-else>
              <v-tooltip top>
                <v-avatar slot="activator" size="65px" color="#00acc2" class="avatar">
                  <v-icon size="35px" color="white">person</v-icon>
                </v-avatar>
                <span>{{item.user}}</span>
              </v-tooltip>
            </div>
          </div>
          <div class="text ml-2">
            <span>Performance: <strong>{{Math.round((item.planned == 0 ? 0 : (item.planned_finalized/item.planned)) * 100)}}%</strong></span>
            <span>Horas Trabalhadas: <strong>{{item.duration_count ? (moment.duration(parseInt(item.duration_count), 'seconds').format("HH:mm", { trim: false })) : '00:00'}}</strong></span>
            <span>Tarefas Concluídas: <strong>{{item.done}}</strong></span>
            <span>Tarefas Previstas: <strong>{{item.planned}}</strong></span>
            <span>Tarefas Atrasadas: <strong>{{item.outdated}}</strong></span>
          </div>
        </div>
      </div>
      <div class="content" v-else>
        <span class="no-data">Não possui registros</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .summary {
    background: #00acc2;
    padding: 2px;
  }

  .summary-title {
    padding: 4px;
    color: #fff;
    display: flex;
    justify-content: space-between;
  }

  .ranking {
    width: 250px;
    height: 28px;
  }

  .content {
    background: #fff;
    padding: 8px;
    display: -webkit-box;
    /* justify-content: space-between; */
  }

  .item {
    display: flex;
    position: Relative;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #00acc2;
    padding: 10px;
    margin: 0 6px;
  }

  .ranking-cicle{
    position: absolute;
    top: -6px;
    left: -8px;
    border-radius: 50%;
    border: 1px solid #00F260;
  }

  .ranking-number {
    font-weight: bold;
  }

  .menu {
    position: relative;
  }

  .paginating {
    position: absolute;
    top: -10px;
    right: 20px;
    display: flex;
    align-items: center;
  }

  .item:nth-of-type(1) {
    margin-left: 0;
  }

  .item .usuario {
    color: #fff;
    background-color: #00acc2;
    border-radius: 50%;
    width: 65px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item .usuario h3 {
    font-size: 2em;
  }

  .item img {
    height: 65px;
    width: 65px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }

  .item .text {
    display: flex;
    flex-direction: column;
  }

  .item .text span>strong {
    font-size: 1.2em;
  }

  @media screen and (min-width: 2500px) {
    .summary-title h2 {
      font-size: 2.5em;
    }

    .dica{
      font-size: 2em;
    }

    .item .text span {
      font-size: 1.5em;
    }

    span.no-data {
      font-size: 2em;
    }
  }
</style>

<script>
  /* eslint-disable eqeqeq */
  import general from '../../../mixin/general'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  momentDurationFormatSetup(moment)

  export default {
    props: ['itemsProp', 'loading'],
    mixins: [general],
    data: () => ({
      timeInterval: 0,
      items: [],
      allItems: [],
      basePath: process.env.API,
      index: 0,
      first: false,
      last: false,
      qtt: 0,
      itemsLength: 0,
      ranking: 0,
      itemsRanking: [ {value: 0, text: 'Sem Ranking'}, {value: 1, text: 'Performance'}, {value: 2, text: 'Horas Trabalhadas'}, {value: 3, text: 'Tarefas Concluídas'}, {value: 4, text: 'Tarefas Atrasadas'} ]
    }),
    mounted () {
      this.createData()
      var clientWidth = (0.0035 * this.$refs.cardSummary.clientWidth) - 0.5218
      this.qtt = Math.ceil(clientWidth + ((clientWidth - Math.trunc(clientWidth)) > 0.5 ? 0 : -0.5))
      if (this.qtt < 1) this.qtt = 1
      this.qttTaskInterval = setInterval(() => {
        var clientWidth = (0.0035 * this.$refs.cardSummary.clientWidth) - 0.5218
        this.qtt = Math.ceil(clientWidth + ((clientWidth - Math.trunc(clientWidth)) > 0.5 ? 0 : -0.5))
        if (this.qtt < 1) this.qtt = 1
        // se o index possuir uma valor maior que o total de paginas ai o index volta para primeiro posição
        if ((this.index + 1) > (Math.ceil(this.itemsLength / this.qtt))) {
          this.index = 0
          this.createData()
        }
      }, 3000)
      this.timeInterval = setInterval(() => {
        if (document.fullscreenElement) {
          if (Math.ceil(this.itemsLength / this.qtt) !== 0) { this.updateData(((this.index + 1) >= Math.ceil(this.itemsLength / this.qtt)) ? -this.index : 1) }
        }
      }, 10000)
    },
    watch: {
      itemsProp () {
        this.createData()
      }
    },
    methods: {
      createData: function (i = this.index) {
        this.items = []
        this.setItemValues()
        this.index = i
        // O index não pode ultrapassar a quantidade total de paginas
        if ((this.index + 1) > Math.ceil(this.itemsLength / this.qtt)) {
          this.index = 0
        }
        this.itemsLength = this.items.length
        this.items = this.items.splice(this.index * this.qtt, this.qtt)
        this.last = ((this.index + 1) === (Math.ceil(this.itemsLength / this.qtt)))
        this.first = (this.index === 0)
      },
      updateData (i) {
        this.setItemValues()
        this.index = this.index + i
        this.items = this.items.splice(this.index * this.qtt, this.qtt)
        this.last = ((this.index + 1) === (Math.ceil(this.itemsLength / this.qtt)))
        this.first = (this.index === 0)
      },
      setItemValues () {
        Object.assign(this.items, this.itemsProp || [])
        // Ordena od dados do resumo de acordo com o ranking selecionado
        switch (parseInt(this.ranking)) {
          case 1: // Performance
            this.items.sort((a, b) => {
              // Caso não tenha tarefas pro periodo considera apenas o done
              let valA = (a['planned'] == 0) ? 0 : (a['planned_finalized'] / a['planned'])
              let valB = (b['planned'] == 0) ? 0 : (b['planned_finalized'] / b['planned'])
              if (valA == valB) return 0
              return (parseFloat(valA) > parseFloat(valB)) ? -1 : 1
            })
            break
          case 2: // Horas trabalhadas
            this.items.sort((a, b) => {
              let valA = a['duration_count'] ? a['duration_count'] : 0
              let valB = b['duration_count'] ? b['duration_count'] : 0
              if (valA == valB) return 0
              return (parseInt(valA) > parseInt(valB)) ? -1 : 1
            })
            break
          case 3: // Tarefas finalizadas
            this.items.sort((a, b) => {
              let valA = a['done']
              let valB = b['done']
              if (valA == valB) return 0
              return (parseInt(valA) > parseInt(valB)) ? -1 : 1
            })
            break
          case 4: // Tarefas Atrasadas
            this.items.sort((a, b) => {
              let valA = a['outdated'] ? a['outdated'] : 0
              let valB = b['outdated'] ? b['outdated'] : 0
              if (valA == valB) return 0
              return (parseInt(valA) < parseInt(valB)) ? -1 : 1
            })
            break
          default: // alfabetica
            this.items.sort((a, b) => {
              let valA = a['user']
              let valB = b['user']
              if (valA == valB) return 0
              return (valA < valB) ? -1 : 1
            })
            break
        }
        // variavel allItems usada para mostrar o posição no ranking, pois o items possui apenas os valores da pagina
        this.allItems = JSON.parse(JSON.stringify(this.items))
      },
      changeRanking (val) {
        this.$emit('changeRanking', val)
        this.setItemValues()
      }
    },
    destroyed () {
      clearInterval(this.timeInterval)
      clearInterval(this.qttTaskInterval)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/cards/CardSummary.vue